import { Loader } from "@googlemaps/js-api-loader";
import { ENV } from "@src/env";
import { type ParentComponent, createContext, onCleanup, onMount } from "solid-js";
import { createStore } from "solid-js/store";
import type { GoogleContextStore } from "./types";

export const googleContext = createContext<GoogleContextStore>({});

export const GoogleProvider: ParentComponent = (props) => {
	const [google, setGoogle] = createStore<GoogleContextStore>({});

	onMount(() => {
		const loader = new Loader({
			apiKey: ENV.VITE_GOOGLE_MAPS_API_KEY,
			version: "weekly",
			libraries: ["places", "maps", "marker"],
		});
		loader.importLibrary("maps").then((map) => setGoogle("map", map));
		loader.importLibrary("places").then((places) => setGoogle("places", places));
		onCleanup(() => {
			loader.deleteScript();
			for (const item of document.getElementsByClassName("pac-container")) item.remove();
		});
	});

	return <googleContext.Provider value={google}>{props.children}</googleContext.Provider>;
};
